/** `/content` того же share → `/image-preview`. Иначе `null`. */
export function diskPreviewUrl(contentUrl: string): string | null {
  const raw = contentUrl.trim();
  if (!raw) return null;

  try {
    const parsed = new URL(raw);
    const path = parsed.pathname.replace(/\/+$/, "") || "/";
    if (path.endsWith("/image-preview")) return parsed.toString();
    if (!path.endsWith("/content")) return null;
    parsed.pathname = `${path.slice(0, -"/content".length)}/image-preview`;
    return parsed.toString();
  } catch {
    if (/\/image-preview\/?$/i.test(raw)) return raw.replace(/\/+$/, "");
    if (!/\/content\/?$/i.test(raw)) return null;
    return raw.replace(/\/content\/?$/i, "/image-preview");
  }
}
